"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setConfig = setConfig;
exports.default = void 0;
let runtimeConfig;
var _default = ()=>{
    return runtimeConfig;
};
exports.default = _default;
function setConfig(configValue) {
    runtimeConfig = configValue;
}

//# sourceMappingURL=runtime-config.js.map